// deps
import React from "react";

// internal-deps
import { GroupOrderState } from "@swiggy-private/cart-types";

// reducers
import { GroupCartAction } from "../reducers/GroupCartReducer";

export interface GroupOrderCartContextValue {
    isGroupCartFlow: boolean;
    setIsGroupCartFlow: (value: boolean) => void;
    state: GroupOrderState;
    setState: React.Dispatch<GroupCartAction>;
}

export const INITIAL_GROUP_ORDER_CONTEXT_VALUE: GroupOrderCartContextValue = {
    isGroupCartFlow: false,
    setIsGroupCartFlow: () => void 0,
    state: {
        data: undefined,
        getSharedCartLoading: true,
        updateSharedCartLoading: false,
        error: {
            error: false,
        },
        isCartLocked: false,
    },
    setState: () => void 0,
};

export const GroupOrderCartContext = React.createContext<GroupOrderCartContextValue>(INITIAL_GROUP_ORDER_CONTEXT_VALUE);

if (__DEV__) {
    GroupOrderCartContext.displayName = "GroupOrderCartContext";
}
